import React from 'react';

import Stack from '@mui/material/Stack';

import EmailVerificationBanner from './EmailVerificationBanner';
import HubSessionBanner from './HubSessionBanner';
import MFABanner from './MFABanner';
import OperatorBanner from './OperatorBanner';
import StationBanner from './StationBanner';

export default function Banners() {
    return (
        <Stack data-noprint spacing={0} sx={{'&:empty': {display: 'none'}}}>
            {/* Session-explaining banners first: each says what the whole
                session is, and the other two never render for those accounts
                anyway. */}
            <OperatorBanner />
            <HubSessionBanner />
            <StationBanner />
            <EmailVerificationBanner />
            <MFABanner />
        </Stack>
    );
}
